/**
 * Email de notificaciones solo según la respuesta JSON de la API .NET
 * (GET /User/{id} o GET /User/me). No usa Laravel ni usuario por cédula del contexto.
 */
export function getNotificationEmailFromNetProfile(apiUser) {
  if (!apiUser || typeof apiUser !== 'object') return null;

  const candidates = [apiUser.Email, apiUser.email];

  for (const c of candidates) {
    if (typeof c === 'string') {
      const t = c.trim();
      if (t.length > 0) return t;
    }
  }
  return null;
}

/** Compatibilidad legada — preferir getNotificationEmailFromNetProfile(apiUser). */
export function resolveDotNetNotificationEmail(usuarioConCedula, apiUser) {
  return getNotificationEmailFromNetProfile(apiUser);
}

/** @deprecated */
export function resolveNotificationEmail(user, usuarioConCedula, apiUser) {
  const candidates = [
    apiUser?.Email,
    apiUser?.email,
    usuarioConCedula?.Email,
    usuarioConCedula?.email,
    user?.Email,
    user?.email,
  ];

  for (const c of candidates) {
    if (typeof c === 'string') {
      const t = c.trim();
      if (t.length > 0) return t;
    }
  }
  return null;
}
